import pb from '../lib/pocketbase';

export async function getDocumentos(page, perPage) {
  return await pb.collection('documento').getList(page, perPage, {
    sort: '-created',
    $autoCancel: false,
  });
}

export async function createDocumento(documento) {
  return await pb.collection('documento').create(documento);
}

export async function updateDocumento(id, documento) {
  return await pb.collection('documento').update(id, documento);
}

export async function deleteDocumento(id) {
  return await pb.collection('documento').delete(id);
}


export async function getImpuestoDocumento(id = null) {
  try {
    // Fetch the impuestos from the 'impuesto_documento' collection, expanding necessary relationships
    const result = await pb.collection('impuesto_documento').getFullList({
      expand: 'documento,impuesto', // Expand the relationships
      filter: `documento="${id}"`, // Correct filter syntax for filtering by documento ID
    });

    // Transform the result into a more usable structure
    const impuestoDocumento = result.map((item) => {
      const documento = item.expand.documento;
      const impuesto = item.expand.impuesto;

      return {
        impuesto: impuesto,
        tasa: item.tasa,
        porc: item.porc,
      };
    });

    return impuestoDocumento; // Return the transformed data
  } catch (error) {
    console.error('Error retrieving impuestos documento:', error);
  }
}